export default {
  v3SubmitErrBtnViewOrder: 'Zobacz Zamówienie',
  v3SubmitErrBtnBackHome: 'Strona Główna',
  v3SubmitErrBtnRetry: 'Ponów',
  v3SubmitErrBtnRelogin: 'Zaloguj się ponownie',
  v3SubmitErrBtnSwitchPay: 'Zmień metodę płatności',
  v3SubmitErrBtnReorder: 'Zamów ponownie',
  v3SubmitErrBtnSwitchServer: 'Zmień serwer',
  v3SubmitErrBtnViewOrderStatus: 'Status zamówienia',
  v3SubmitErrBtnBackStore: 'Wróć do sklepu',
  v3SubmitErrBtnGoUpdate: 'Zaktualizuj',
  v3SubmitErrBtnResubscribe: 'Odnów subskrypcję',
  v3SubmitErrTipUpdateApp: 'Zaktualizuj w sklepie z aplikacjami',
  v3SubmitErrTipRelogin: 'Proszę zalogować się ponownie',

  v3SubmitErrMsg120009: 'Zamówienie przetworzone – sprawdź plecak w grze.',
  v3SubmitErrMsg120003: 'Błąd w informacji o produkcie – wybierz ponownie.',
  v3SubmitErrMsg120016: 'Zbyt wiele próśb – odczekaj kilka sekund i spróbuj ponownie.',
  v3SubmitErrMsg120025: 'Nieprawidłowe parametry żądania – zaloguj się ponownie i spróbuj.',
  v3SubmitErrMsg121012: 'Kanał płatności chwilowo niedostępny – spróbuj innej metody.',
  v3SubmitErrMsg120012: 'Niestabilna sieć – sprawdź połączenie i spróbuj ponownie.',
  v3SubmitErrMsg120002: 'Nie znaleziono postaci – najpierw ją utwórz.',
  v3SubmitErrMsg121019: 'Błąd w informacji o zamówieniu – złóż nowe zamówienie.',
  v3SubmitErrMsg120024: 'Prezent przedrejestracyjny już odebrany – nie powtarzaj.',
  v3SubmitErrMsg120000: 'Sesja wygasła – zaloguj się ponownie.',
  v3SubmitErrMsg120014: 'Nieprawidłowy numer zamówienia – złóż nowe zamówienie.',
  v3SubmitErrMsg121001: 'Doładowanie do gry nieudane – spróbuj ponownie później lub skontaktuj się z pomocą.',
  v3SubmitErrMsg120015: 'Nieprawidłowa kwota płatności – wybierz produkt ponownie.',
  v3SubmitErrMsg120001: 'Serwer nie pasuje – przełącz na właściwy serwer.',
  v3SubmitErrMsg120020: 'Kanał płatności zwrócił błąd – spróbuj innej metody.',
  v3SubmitErrMsg120010: 'Funkcja doładowania tymczasowo wyłączona – spróbuj później.',
  v3SubmitErrMsg120006: 'Weryfikacja kwoty nieudana – wybierz ponownie.',
  v3SubmitErrMsg121010: 'Żądanie doładowania w środowisku testowym jest nieprawidłowe – użyj wersji oficjalnej.',
  v3SubmitErrMsg120017: 'Duplikat numeru zamówienia – sprawdź, czy już opłacone.',
  v3SubmitErrMsg120022: 'Weryfikacja callbacka płatności nieudana – spróbuj ponownie później.',
  v3SubmitErrMsg121000: 'System zajęty – spróbuj ponownie później.',
  v3SubmitErrMsg120011: 'Błędny ID produktu – wybierz ponownie.',
  v3SubmitErrMsg121015: 'Weryfikacja kwoty płatności nieudana – złóż nowe zamówienie.',
  v3SubmitErrMsg120004: 'Ten kanał płatności nie jest otwarty – wybierz inną metodę.',
  v3SubmitErrMsg120005: 'Kanał płatności w trakcie konserwacji – użyj innej metody.',
  v3SubmitErrMsg120007: 'Nieprawidłowy ID platformy – zaloguj się ponownie.',
  v3SubmitErrMsg120008: 'Niewystarczające parametry żądania – wyślij ponownie.',
  v3SubmitErrMsg120013: 'Nieprawidłowy numer zamówienia dewelopera – złóż nowe zamówienie.',
  v3SubmitErrMsg120018: 'Płatność zablokowana przez kontrolę ryzyka – skontaktuj się z pomocą w celu weryfikacji.',
  v3SubmitErrMsg120019: 'Weryfikacja nazwy pakietu nieudana – użyj wersji oficjalnej.',
  v3SubmitErrMsg120021: 'Weryfikacja ID produktu nieudana – wybierz ponownie.',
  v3SubmitErrMsg120023: 'Błąd przy przyznawaniu prezentu przedrejestracyjnego – sprawdź później.',
  v3SubmitErrMsg120026: 'Konto nie istnieje – sprawdź stan konta.',
  v3SubmitErrMsg120030: 'Niewystarczający całkowity stan magazynowy – wybierz inny produkt.',
  v3SubmitErrMsg120031: 'Przekroczyłeś limit zakupu tego produktu – dostosuj.',
  v3SubmitErrMsg120032: 'Wersja gry zbyt stara – pobierz najnowszą wersję.',
  v3SubmitErrMsg120080: 'Płatność przez agenta ograniczona przez kontrolę ryzyka – użyj własnej metody płatności.',
  v3SubmitErrMsg120081: 'Płatność przez agenta opóźniona przez kontrolę ryzyka – sprawdź wynik później.',
  v3SubmitErrMsg121002: 'Pamięć podręczna zamówienia nieprawidłowa – złóż nowe zamówienie.',
  v3SubmitErrMsg121003: 'Konfiguracja doładowania nie znaleziona – skontaktuj się z pomocą.',
  v3SubmitErrMsg121004: 'Niewystarczające parametry rozszerzone – wyślij ponownie.',
  v3SubmitErrMsg121005: 'Zapis do pamięci podręcznej nieudany – spróbuj później.',
  v3SubmitErrMsg121006: 'Odczyt pamięci podręcznej nieudany – spróbuj później.',
  v3SubmitErrMsg121007: 'Błąd konfiguracji typu doładowania – skontaktuj się z pomocą.',
  v3SubmitErrMsg121011: 'Wykryto nowe pola od Apple – zaktualizuj aplikację.',
  v3SubmitErrMsg121013: 'Zamówienie odnowienia nie znalezione – subskrybuj ponownie.',
  v3SubmitErrMsg121014: 'Deszyfrowanie parametrów doładowania nieudane – wyślij ponownie.',
  v3SubmitErrMsg121017: 'To zamówienie zostało zwrócone – skontaktuj się z pomocą w celu potwierdzenia.',
  v3SubmitErrMsg121018: 'Subskrypcja wygasła – odnów subskrypcję.',
  v3SubmitErrMsg121020: 'Zamówienie anulowane – złóż nowe zamówienie.',
  v3SubmitErrMsg121021: 'Błąd API Google – spróbuj ponownie później.',
  v3SubmitErrMsg121022: 'Nie udało się pobrać tokena dostępu – zaloguj się ponownie.',
  v3SubmitErrMsg121023: 'Nieprawidłowy status zamówienia – sprawdź status wpływu.',
  v3SubmitErrMsg121024: 'Potwierdzenie zamówienia nieudane – spróbuj ponownie później.'
};
